/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  CircularProgress,
  Grid,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {
  addComment,
  changeStatus,
} from '@pingum/app-state-management/event/actions';
import StatusAssignment from '../../StatusAssignment';
import noChangeStatus from './noChangeStatus';
import styles from './styles';

class AddCommentCard extends React.Component {
  constructor(props) {
    super(props);

    this.noChangeStatus = noChangeStatus;

    let actionTypeStatus = null;
    if (this.props.actionType === 'Comment') {
      actionTypeStatus = noChangeStatus;
    }
    if (this.props.actionType === 'Complete') {
      actionTypeStatus = this.props.statuses.find((s) => s.endingStatus)
    }

    this.state = {
      selectedStatus: actionTypeStatus,
      comment: '',
      assignment: '',
      isValidStatus: true,
      isValidAssignment: true,
      workflowStatus: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedEvent && prevProps.selectedEvent.id !== this.props.selectedEvent.id
       && this.props.selectedEvent.currentEventStatus && this.props.selectedEvent.currentEventStatus.assignment) {
      // if current status has assignment, carry that over to the next status by default
      this.setState({ assignment: this.props.selectedEvent.currentEventStatus.assignment });
    }
    if (this.props.selectedEvent && prevProps.selectedEvent.id && this.props.actionType && this.props.actionType !== prevProps.actionType) {
      let actionTypeStatus = null;
      if (this.props.actionType === 'Comment') {
        actionTypeStatus = this.noChangeStatus;
      }
      if (this.props.actionType === 'Complete') {
        actionTypeStatus = this.props.statuses.find((s) => s.endingStatus)
      }
      this.setState({ selectedStatus: actionTypeStatus });
    }
  }

  handleSelectedStatusChange = (selectedStatus) => {
    if (selectedStatus.id === this.props.selectedEvent.currentEventStatus.status.id) {
      return;
    }
    this.setState({
      selectedStatus,
      isValidStatus: true,
    });
  }

  handleWorkflowStatusChange = (workflowStatus) => {
    this.setState({
      workflowStatus,
      isValidAssignment: true,
    });
  }

  handleAssignmentChange = (newUsers) => {
    const { workflowStatus } = this.state;

    this.setState({
      assignment: newUsers,
      isValidAssignment: !workflowStatus || !workflowStatus.requiredAssignment || !!newUsers,
    });
  }

  handleCommentChange = (e) => {
    const comment = e.target.value;
    const { requireComment } = this.state.selectedStatus;
    this.setState({
      comment,
      isValidStatus: !(requireComment && comment.trim().length === 0),
    });
  }

  handleSuccessfulUpdate = () => {
    this.setState({
      comment: '',
      selectedStatus: this.noChangeStatus,
      isValidStatus: true,
      isValidAssignment: true,
      workflowStatus: null,
    });
    this.props.onSuccessfulAction()
  }

  handleUpdateClick = () => {
    let allValid = true;
    if (this.state.selectedStatus.requireComment && this.state.comment.trim().length === 0) {
      this.setState({ isValidStatus: false });
      allValid = false;
    }
    if (this.state.workflowStatus && this.state.workflowStatus.requiredAssignment && !this.state.assignment) {
      this.setState({ isValidAssignment: false });
      allValid = false;
    }
    if (!allValid) {
      return false;
    }

    if (this.state.comment && this.state.selectedStatus.id < 0) {
      return this.props.addComment(
        this.props.selectedEvent.id,
        { comment: this.state.comment },
        this.handleSuccessfulUpdate,
      );
    }

    return this.props.changeStatus(
      this.props.selectedEvent.id,
      {
        statusId: this.state.selectedStatus.id,
        statusComment: this.state.comment,
        completeEvent: this.state.selectedStatus.endingStatus,
        assignment: this.state.assignment || null,
      },
      this.handleSuccessfulUpdate,
    );
  }

  canUpdate = () => (this.state.selectedStatus && (this.state.selectedStatus.id > -1 || this.state.comment || !this.state.isValidStatus))

  render() {
    const {
      isLoading,
      selectedEvent,
    } = this.props;
    const {
      comment,
      assignment,
      selectedStatus,
      isValidStatus,
      isValidAssignment,
    } = this.state;

    return (
      <Grid container spacing={2} sx={{ mt: 1 }} justifyContent="flex-end">
        <Grid item xs={12}>
          <StatusAssignment
            allowNoStatusChange
            showStatusCommentField
            comment={comment}
            assignment={assignment}
            selectedStatus={selectedStatus}
            event={selectedEvent}
            eventStatus={selectedEvent.currentEventStatus}
            isValidStatus={isValidStatus}
            isValidAssignment={isValidAssignment}
            handleSelectedStatusChange={this.handleSelectedStatusChange}
            handleWorkflowStatusChange={this.handleWorkflowStatusChange}
            handleAssignmentChange={this.handleAssignmentChange}
            handleCommentChange={this.handleCommentChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Button
            size="small"
            color="primary"
            disabled={!this.canUpdate() || isLoading}
            onClick={this.handleUpdateClick}
            variant="contained"
            startIcon={
              isLoading
                && (<CircularProgress size={24} />)
            }
            sx={{ width: '100%' }}
          >
            {
              (selectedStatus && selectedStatus.id && selectedStatus.id < 0) && 'Add Comment'
            }
            {
              (selectedStatus && selectedStatus.id && selectedStatus.id > 0 && selectedStatus.endingStatus && selectedStatus.archiveStatus) && 'Complete and Delete Task'
            }
            {
              (selectedStatus && selectedStatus.id && selectedStatus.id > 0 && selectedStatus.endingStatus && !selectedStatus.archiveStatus) && 'Complete Task'
            }
            {
              (selectedStatus && selectedStatus.id && selectedStatus.id > 0 && !selectedStatus.endingStatus && selectedStatus.archiveStatus) && 'Delete Task'
            }
            {
              (selectedStatus && selectedStatus.id && selectedStatus.id > 0 && !selectedStatus.endingStatus && !selectedStatus.archiveStatus) && 'Change Status'
            }
          </Button>
        </Grid>
      </Grid>
    );
  }
}

AddCommentCard.propTypes = {
  addComment: PropTypes.func,
  selectedEvent: PropTypes.object,
  changeStatus: PropTypes.func,
  onSuccessfulAction: PropTypes.func,
  isLoading: PropTypes.bool,
  actionType: PropTypes.string,
  statuses: PropTypes.array,
};

AddCommentCard.defaultProps = {
  addComment: () => {},
  selectedEvent: {},
  changeStatus: () => {},
  onSuccessfulAction: () => {},
  isLoading: false,
  actionType: 'Comment',
  statuses: [],
};

export const mapStateToProps = (state) => ({
  selectedEvent: state.event.selectedEvent,
  statuses: state.status.statuses,
  isLoading:
    state.event.isAddingComment
    || state.event.isChangingStatus,
});

export const mapDispatchToProps = (dispatch) => ({
  addComment: (id, comment, successCallback) => dispatch(addComment(id, comment, successCallback)),
  changeStatus: (id, status, successCallback) => dispatch(changeStatus(id, status, successCallback)),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCommentCard));
